import React, { useEffect, useContext, useRef } from 'react';
import { Sections } from 'features/page-navigation/components/section-refs-context';
import { useInView } from 'react-cool-inview';
import { getObserverConfig } from './utils';

export const ObserverComponent: React.FC<{
  id: string;
  index: number;
  total: number;
  onChange: (id: string, visible: boolean) => void;
}> = ({ id, index, total, onChange }) => {
  const context = useContext(
    Sections.Context as React.Context<Map<string, React.MutableRefObject<HTMLElement | null>>>,
  );
  const refObject = context.get(id);
  const ref = useRef<HTMLElement | null>(null);

  const { observe, inView } = useInView({
    ...getObserverConfig(index, total),
  });

  useEffect(() => {
    if (refObject?.current) {
      observe(refObject.current);
      ref.current = refObject.current;
    }
  }, [observe, refObject]);

  useEffect(() => onChange(id, inView), [inView, id, onChange]);
  return null;
};
